export default __webpack_public_path__ + "static/media/Team3.6fa8b6c1.jpg";